// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__30xCO","author":"Table_author__1aIV1","authorImage":"Table_authorImage__3ptyP","unreadRow":"Table_unreadRow__2X-u-"};